import { render, staticRenderFns } from "./ViewProduct.vue?vue&type=template&id=421358ac&scoped=true&"
import script from "./ViewProduct.vue?vue&type=script&lang=js&"
export * from "./ViewProduct.vue?vue&type=script&lang=js&"
import style0 from "./ViewProduct.vue?vue&type=style&index=0&id=421358ac&lang=scss&"
import style1 from "./ViewProduct.vue?vue&type=style&index=1&id=421358ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421358ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('421358ac')) {
      api.createRecord('421358ac', component.options)
    } else {
      api.reload('421358ac', component.options)
    }
    module.hot.accept("./ViewProduct.vue?vue&type=template&id=421358ac&scoped=true&", function () {
      api.rerender('421358ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/products/ViewProduct.vue"
export default component.exports